if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(search, replace) {
    // If search is a string, escape any RegExp special characters
    if (typeof search === 'string') {
      search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    return this.replace(new RegExp(search, 'g'), replace);
  };
}
